import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { InternalDealTag } from '@dealstack/shared/lib/generated';

export const getInternalDealTagTranslation = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	internalDealTag: InternalDealTag
): string => {
	switch (internalDealTag) {
		case InternalDealTag.SUPPORT:
			return tCommonUI('internal_deal_tag.support');
		case InternalDealTag.SALES_DEMO:
			return tCommonUI('internal_deal_tag.sales_demo');
		case InternalDealTag.ONBOARDING:
			return tCommonUI('internal_deal_tag.onboarding');
		case InternalDealTag.LIVE:
			return tCommonUI('internal_deal_tag.live');
		case InternalDealTag.LEGACY:
			return tCommonUI('internal_deal_tag.legacy');
	}
};

export const makeInternalDealTagDropdownOptions = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>
): { value: InternalDealTag; label: string }[] =>
	Object.values(InternalDealTag).map((value) => ({
		value,
		label: getInternalDealTagTranslation(tCommonUI, value),
	}));
